import {
  FETCH_GAMES_REQUEST,
  FETCH_GAMES_SUCCESS,
  FETCH_GAMES_FAILURE,
} from './types';
import dataManager from '../../data/DataManager';

// 获取所有游戏
export const fetchAllGames = () => async (dispatch) => {
  try {
    dispatch({ type: FETCH_GAMES_REQUEST });
    
    const games = dataManager.getAllGames();
    
    dispatch({
      type: FETCH_GAMES_SUCCESS,
      payload: games
    });
  } catch (error) {
    console.error('Fetch all games error:', error);
    dispatch({
      type: FETCH_GAMES_FAILURE,
      payload: error.message
    });
  }
};

// 根据分类获取游戏
export const fetchGamesByCategory = (categorySlug) => async (dispatch) => {
  try {
    dispatch({ type: FETCH_GAMES_REQUEST });

    const games = categorySlug ? 
      dataManager.getGamesByCategory(categorySlug) : 
      dataManager.getAllGames();

    dispatch({
      type: FETCH_GAMES_SUCCESS,
      payload: games
    });
  } catch (error) {
    console.error('Fetch games by category error:', error);
    dispatch({
      type: FETCH_GAMES_FAILURE,
      payload: error.message
    });
  }
};

// 获取游戏详情
export const fetchGameDetails = (gameSlug) => async (dispatch) => {
  try {
    dispatch({ type: FETCH_GAME_DETAILS_REQUEST });

    const gameDetails = dataManager.getGameBySlug(gameSlug);
    
    if (!gameDetails) {
      throw new Error('Game not found');
    }

    dispatch({
      type: FETCH_GAMES_SUCCESS,
      payload: gameDetails
    });
  } catch (error) {
    console.error('Fetch game details error:', error);
    dispatch({
      type: FETCH_GAMES_FAILURE,
      payload: error.message
    });
  }
};

// 获取热门游戏
export const fetchHotGames = (limit = 10) => async (dispatch) => {
  try {
    dispatch({ type: FETCH_GAMES_REQUEST });

    const hotGames = dataManager.getHotGames(limit);

    dispatch({
      type: FETCH_GAMES_SUCCESS,
      payload: hotGames
    });
  } catch (error) {
    console.error('Fetch hot games error:', error);
    dispatch({
      type: FETCH_GAMES_FAILURE,
      payload: error.message
    });
  }
};

// 搜索游戏
export const searchGames = (searchTerm) => async (dispatch) => {
  try {
    dispatch({ type: FETCH_GAMES_REQUEST });

    // 从所有游戏中搜索
    const allGames = dataManager.getAllGames();
    const searchResults = allGames.filter(game => 
      game.title.toLowerCase().includes(searchTerm.toLowerCase())
    );

    dispatch({
      type: FETCH_GAMES_SUCCESS,
      payload: searchResults
    });
  } catch (error) {
    console.error('Search games error:', error);
    dispatch({
      type: FETCH_GAMES_FAILURE,
      payload: error.message
    });
  }
};
